import React from "react";
import classes from './Island.module.css'
import { useSelector } from "react-redux";

const Island = ({ positions, heightSumMapsCreated, selectedLevelClass, lastLevelClass, svgIslandsImgsArr }) => {
    const { ignoreIslandBorder } = useSelector((state) => state.application);
    
    return (
        <div className={`${classes.LevelOnMapLayer1} ${selectedLevelClass && classes[selectedLevelClass]} ${lastLevelClass && classes[lastLevelClass]}`}
            style={{
                bottom: `${positions.bottom + heightSumMapsCreated}px`,
                left: `${positions.left}px`,
                width: `${positions.width}px`,
                height: `${positions.height}px`
            }}>
            {!ignoreIslandBorder && <div className={classes.SvgWrap}>{svgIslandsImgsArr}</div>}
        </div>
    )
}

export default Island